import {action, observable} from "mobx"
import shop from "shop/shop"
import languageStore from "stores/languageStore"

import _ from "lodash"
import cmsStore from "stores/cmsStore"

class CategoryStore {

	@observable categories = []
	@observable rootCategories = []
	@observable rootFields = {}
	@observable categoriesById = new Map() // rename to singular
	@observable categoryByProductId = new Map()
	@observable categoryByName = new Map()
	@observable all = []
	@observable hasFilter = false
	@observable hash = 0

	_fieldDataByFieldName = {}

	@action fetch() {
		const {currentLanguage} = languageStore
		return shop.fetch( `/shop/rest/data/categories/tree?lang=${currentLanguage}`, {
				credentials: "include",
				mode       : "cors",
			} )
			.then( categories => {
				console.time( "CATEGORIES" )
				this.categories = this.mapCategories( categories )
				console.timeEnd( "CATEGORIES" )

				this.sortRootCategories()
				return this.categories
			} )
			.catch( err => {
				console.error( "Error fetching categories", err )
			} )
	}

	@action
	fetchCategoryMeta( categoryId ) {
		const {currentLanguage} = languageStore
		return shop.fetch( `/shop/rest/data/categories/entries/${categoryId}?lang=${currentLanguage}`, {
				credentials: "include",
				mode       : "cors",
			} )
			.then( category => {
				let partialCategory = this.categoriesById.get( categoryId )
				let mergedCategory = {...partialCategory, ...category}
				this.categoriesById.set( mergedCategory.map_id, mergedCategory )
				this.categoryByName.set( mergedCategory.desc.des, mergedCategory )
				return category
			} ).catch( err => {
				console.error( "Error fetching category meta", err )
			} )
	}

	_categoryIdFieldsPromises = {}

	@action
	loadTranslatedFieldsForCategory = async ( categoryId ) => {
		if ( this._categoryIdFieldsPromises[categoryId] ) return true

		let category = this.categoriesById.get( categoryId )
		if ( !category ) {
			console.warn( `${categoryId} not found` )
			return false
		}
		// GET FIELDS
		let fieldNames = Object.keys( category.meta.submeta.fields )
		let p = []
		while ( fieldNames.length ) {
			let fieldName = fieldNames.pop()
			p.push( this.loadTranslatedFields( {locale: "de", fieldName} ) )
		}
		await Promise.all( p )
		this._categoryIdFieldsPromises[categoryId] = true
		return true
	}

	getFieldConfigForKey( fieldName, key ) {
		let conf = shop.config[`${fieldName}ByKey`]
		if ( conf ) {
			return conf[key]
		}
		return false
	}

	loadTranslatedFields = async ( {locale = "de", fieldName} ) => {
		let hash = `${locale}-${fieldName}`

		if ( this._fieldDataByFieldName[hash] ) return this._fieldDataByFieldName[hash]

		if ( !locale || !fieldName ) throw Error( "Invalid field translation request" )
		let p = shop.fetch( `/shop/rest/data/fields/${fieldName}?lang=${locale}` )
			.then( fields => {
				let translations = {}
				let byKey = {}
				let global = {}
				fields.forEach( field => {
					if ( field.key === "global" ) {
						translations[`${fieldName}`] = field.text
						global = field
					}
					byKey[field.key] = field

				} )

				languageStore.addLanguage( locale, translations )
				cmsStore.addConfig( fieldName, fields )
				cmsStore.addConfig( `${fieldName}ByKey`, byKey )
				cmsStore.addConfig( `${fieldName}_global`, global )

				return fields
			} )

		this._fieldDataByFieldName[hash] = p
		return p
	}

	@action
	fetchCategory( categoryId ) {
		const {currentLanguage} = languageStore
		return shop.fetch( `/shop/rest/data/categories/entries/${categoryId}?lang=${currentLanguage}`, {
				credentials: "include",
				mode       : "cors",
			} )
			.then( category => {
				let partialCategory = this.categoriesById.get( categoryId )
				let mergedCategory = {...partialCategory, ...category}
				console.log( "CATEGORY", {mergedCategory} )
				this.categoriesById.set( mergedCategory.map_id, mergedCategory )
				this.categoryByName.set( mergedCategory.desc.des, mergedCategory )
			} )
	}

	@action
	showFilter() {
		this.hasFilter = true
	}

	@action
	hideFilter() {
		this.hasFilter = false
	}

	@action
	updateCategories() {
		this.all.forEach( category => category.update() )
		this.hash += 1
	}

	mapCategories = ( categories, level = 0 ) => {
		const sorted = categories.sort( CategoryStore.baseSort ).map( data => {
			let category = new shop.CategoryModel( data )
			category.level = level
			if ( category.level === 0 ) {
				this.rootCategories.push( category )
			}
			//parse categories with article ids
			let parts = category.title.split( " " )
			let productId = parts[0]
			if ( productId ) {
				this.categoryByProductId.set( productId, category )
			}
			category.children = this.mapCategories( category.children, level + 1 )
			this.categoriesById.set( category.map_id, category )
			this.categoryByName.set( category.desc.des, category )
			this.all.push( category )
			return category
		} )

		return sorted
	}

	sortRootCategories() {
		const buckets = {}

		this.rootCategories.forEach( category => {
			let fields = category.meta.submeta.fields
			if ( shop.config.pickFilter ) {
				fields = _.pick( category.meta.submeta.fields, shop.config.pickFilter )
			}
			_.forEach( fields, ( values, key ) => {
				const bucket = buckets[key] || {}
				values.forEach( value => {
					bucket[value] = true
				} )
				buckets[key] = bucket
			} )
		} )

		this.rootFields = buckets
	}

	static baseSort( a, b ) {
		if ( !a || !b ) return 0
		let aSort = a.sort
		let bSort = b.sort
		if ( aSort === "" ) aSort = Infinity
		if ( bSort === "" ) bSort = Infinity
		if ( Number( aSort ) < Number( bSort ) ) return -1
		return 0
	}


}

const categoryStore = new CategoryStore()

window["categoryStore"] = categoryStore
export {CategoryStore}
export default categoryStore



// WEBPACK FOOTER //
// ./src/stores/categoryStore.js